import axios from "axios";
import React, { Component,useEffect } from "react";
import {Link} from "react-router-dom";

import { connect } from "react-redux";
import {set_datapage, SetLanguage, getLanguage} from 'redux/actions/DataPageAction'

import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";
import "css/reportes/reportes.css";
import qs from 'query-string'
import {PageLength} from "helpers/Datatables";
import $ from 'jquery'
import dt from 'datatables.net'
import Swal from "sweetalert2";

$.DataTable = dt


class ListaPersonas extends Component {
    txt_key = 'none'
    constructor (props) {
        super(props)
        console.log('this.props.match.params', this.props, this.props.match.params)
        this.txt_key = this.props.match.params.type !== undefined ? this.props.match.params.type : 'none'
        this.props.set_datapage({ titulo: 'Lista de Personas en la Base de Datos',
                                isbackend:false,
                                be_itemselect:"rec_importar_excel",//clave de item del menu backend que se debe activar 
                                breadcrumb:[
                                    {name:"Inicio",url:localUrl("/")},
                                    {name:"Reportes",url:"#"},
                                    {name:"Lista de Personas",url:"#",active:true},
                                ]});
      
        this.state = {
            variable: {
              name: '',
              description: '',
              key: undefined

            },
            lista: false,
            tipo: false,
            linea: false,
            pais:false,
            listainstitucion:false,
            tipoestandar:false,
            total:0,
            search:{txt_recurso:"",sel_tipo: "", sel_linea: "", sel_pais: "", sel_institucion: "", sel_tiporecurso: "",showi:0,modulo:''},
            regpag:process.env.REG_PAG,
            isloadsearchinit:false,
            showinstitucion:false,
            institucion:false,
            modulo:false
          };
       
    }
    componentDidMount() {
     
        axios.get(baseUrl('cites/variable/key/' + this.txt_key)).then(res => {
            this.initpage(res.data);
        })
        this.initDatatable()
    }
    initpage(result){
        this.setState({
            variable: {
                name: result.data?.var_txt_name,
                description: result.data?.var_txt_description,
                key: result.data?.var_txt_key,
            }
        })
        console.log('ccccccccc')
        
       
        
    }
    getFilter(){
        return  {
            q1: this.state.search['txt_recurso'],
            q2: this.state.search['sel_tipo'],
            q3: this.state.search['sel_linea'],
            q4: this.state.search['sel_pais'],
            q5: this.state.search['sel_institucion'],
            q6: this.state.search['sel_tiporecurso'],
            showi: this.state.search['showi'],
            modulo: this.state.search['modulo'],
            }
      
    }
    initDatatable = () => {
        
        console.log('asdasdasd')
        const OnClick_acciones = (evt) => {
             let {accion, id} = evt.currentTarget.dataset
            // switch (accion) {
            //     case 'ver':
            //     this.props.history.push(localUrl("/reportes/listarecursos/" + id))
            //     break;
            // }
        }
        const OnCall = () => {

            this.setState({                   
                isloadsearchinit: true
            })
            
        }
        const OnFinish = () => {
    
            this.setState({                   
                isloadsearchinit: false
            })
            
        }
        
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'table-container't>>><'columns p-4'<'column'l><'column'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("cites/personas/datatable?key=" + (this.txt_key === 'none' ? '' : this.txt_key)),
              data: (d) => {
                
                // d.filter = this.getFilter()
                return d
              },
              beforeSend: function () {
                OnCall(); // show wating animation
              },
              error: function (xhr, error, thrown) {
                OnFinish()
                //alert(xhr.status);
                //alert(thrown);
                Swal.fire({
                    title: thrown,
                    html: `
                     <p> Se encontró un error en el servidor, intente más tarde.</p>
                     <p>Mensaje: ${xhr.status} - ${error}</p>
                    `,
                    icon: 'error'
                }).then(sr => {
                    
                  })
                
              }
            },
            serverSide: true,
            order: [[0, "asc"]],
            createdRow: (r, d, i) => {
            },
            columns: [
              { data: "per_int_id" },
              { data: "per_txt_name" },
              { data: "per_txt_last_name" },
              { data: "per_txt_sex" },
              { data: "per_txt_phone" },
              { data: "per_txt_email" },
              { data: "pai_txt_name" },
              { data: "per_int_id", render: (d, t, r) => {
                  return `
                  <div class="buttons is-centered">
                    <a class="button is-small is-primary" target="_blank" href="${localUrl("/config/personas/" + d)}">
                    <span class="icon"><i class="mdi mdi-eye"></i>
                    </span>
                  </a>   
              </div> `
              }, orderable: false }
            ],
            drawCallback: (dcall) => {
                this.setState({                   
                    total:dcall._iRecordsDisplay
                })

                $('#tblRepPersonas_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#tblRepPersonas_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblRepPersonas_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblRepPersonas_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#tblRepPersonas_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#tblRepPersonas')
        
        // setTimeout(() => {
            
        this.datatable = this.table.DataTable(this.configDT).on('click', '.btn-acciones', OnClick_acciones)

        // }, 20000)
    }

    
    
    buscar_simple = () => {
        this.getSearch();
        var url=this.getParamsUrl("/reportes/listarecursos?");  
        this.props.history.push(localUrl(url))      
    }
    getSearch(){
        this.datatable.draw()
        
    }
    getParamsUrl(url){
       

    }

    gestionarCambio = (event) => {
        var search=this.state.search
        if (event.target.type === "radio") {
            search[event.target.name]=event.target.value;
        } else {
            search[event.target.id]=event.target.value;
        }
        this.setState({          
            search:search
        })
      };

    render() {
        return (
<div>
   <section className="section is-main-section">
      {!this.state.isloadsearchinit?
        (
            <p className='has-text-centered m-5 '>{this.props.language('cargando')}...</p>
        ):
        (
            <div className={'card ' + (this.state.variable.key === undefined ? 'is-hidden' : '')}>
                <header className="card-header">
                    <p className="card-header-title">
                        {this.props.language('detalle_tipo_institucion','Detalle por tipo de Institución')}
                    </p>
                </header>
                <div className="card-content">
                    <p className="title is-4">
                    {this.state.variable.name}
                    </p>
                    {/* <p className="subtitle is-6 mb-1">
                        <span className="tag m-1 ml-0 is-success">{this.state.institucion.pai_txt_name}</span>
                        <span className="tag m-1 is-info">{this.state.modulo.var_txt_name}</span>
                        <span className="tag m-1"><strong> {this.state.institucion.var_txt_name}</strong></span>
                    </p> */}
                
                <p className="subtitle is-6">
                {this.state.variable.description}
                </p>
                </div>
            </div>         
        )        
      }
      <div className="card has-table">
          
         <div className="column">
            <div align="right">
                
               <a className="button is-primary" href={baseUrl('cites/reportes/getexcel?c=getRerecursosDT&filter_json=')+JSON.stringify(this.getFilter())}>{this.props.language('expor_excel','Exportar a Excel')}</a>
            </div>
         </div>
         
         <div className="notification is-card-toolbar">
            <div className="level">
               <div className="level-left">
                  <strong> {this.props.language('expor_listresultados', 'Lista de resultados')}</strong> 
               </div>
               <div className="level-right">
                  <div className="level-item">
                     {this.state.total} {this.props.language('registros', 'registros')}                                      
                  </div>
               </div>
            </div>
         </div>
         <div className="card-content">
            <div className="b-table has-pagination">
               <div className="table-wrapper has-mobile-cards">
                  <table id="tblRepPersonas" className="table is-fullwidth is-striped is-hoverable is-fullwidth">
                     <thead>
                     <tr>                                        
                                <th className="is-sortable">#</th>
                                <th className="is-capitalize">{ this.props.language('nombre')}</th>
                                <th className="is-capitalize">{ this.props.language('apellidos')}</th>
                                <th className="is-capitalize">{ this.props.language('sexo')}</th>
                                <th className="is-capitalize">{ this.props.language('teléfono')}</th>
                                <th className="is-capitalize">{ this.props.language('correo')}</th>
                                <th className="is-capitalize">{ this.props.language('país')}</th>
                                <th></th>
                                </tr>
                     </thead>
                     <tbody>
                        {this.state.lista}                          
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </div>
   </section>
</div>
          )
    }
}

const md = state => {

}
export default connect(getLanguage, {set_datapage, SetLanguage})(ListaPersonas)